import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  pegawaiService = {}

pegawaiService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiService.show = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.init_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai/init_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.get_import_progress = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai/get_import_progress',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.save_import_batch = function (token, data) {
    return fetch({
        url: '/transaksi/pegawai/save_import_batch',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiService.pegawai_per_pengawas = function (token,data='') {
    return fetch({
        url: '/ref/pegawai_per_pengawas',
        method: 'post',
        params: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiService.pegawai_per_proyek = function (token,data='') {
    return fetch({
        url: '/ref/pegawai_per_proyek',
        method: 'post',
        data: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiService.pegawai_per_tanggal_bayar = function (token,data='') {
    return fetch({
        url: '/ref/pegawai_per_tanggal_bayar',
        method: 'post',
        data: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default pegawaiService;
